import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

type Props = {
    token: string;
}

type HandlerType = Handler<HasOnComplete<Props>, Props>;

const LoadToken: HandlerType = async (props) => {
    props.token = await get<string>("/api/v1/securitytokens", { cacheBuster: Date.now() } as ApiParameter);
}

export const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/ServerSideRendering/SecurityToken/Set",
        value: props.token,
    });
}

const FireOnComplete: HandlerType = props => {
    if (props.token) {
        props.parameter.onComplete?.({ token: props.token });
    }
}

const chain = [
    LoadToken,
    UpdateState,
    FireOnComplete,
];

const getSecurityToken = createHandlerChainRunner(chain, "GetSecurityToken");
export default getSecurityToken;